// extracted by mini-css-extract-plugin
export var bubble = "_16-0";
export var container = "_16-3";
export var contrastBorder = "_16-4";
export var greyOut = "_16-2";
export var initialsWrapper = "_16-1";
export var large = "_16-9";
export var medium = "_16-8";
export var mediumSmall = "_16-7";
export var mediumSmallMedium = "_16-c";
export var micro = "_16-5";
export var small = "_16-6";
export var tiny = "_16-b";
export var xTiny = "_16-a";